import { Box } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { widgetItemStyle, widgetItemCountStyle, widgetItemTitleStyle } from 'basics/styles/widget.style';
import useCountCepWidget from 'components/CountWidgets/CountCepWidget/CountCepWidget.hook';
import { CountWidgetPropsType } from 'components/CountWidgets/CountWidget.types';
import Loader from 'yoda-ui/components/Loader';
import { YodaColors } from 'yoda-ui/yodaTheme';

const CountCepWidget: FC<CountWidgetPropsType> = ({
  filters,
  useAdminFilters,
}) => {
  const { value, loading } = useCountCepWidget(filters, useAdminFilters);
  const { t } = useTranslation();

  return (
    <Box sx={ widgetItemStyle } >
      <Box sx={ widgetItemTitleStyle }>
        <img src='/dashboard/CEP-icon.svg' alt="CEP-icon" style={ { height: 'inherit' } } />
        { t('maya_count_cep_widget_label') }
      </Box>
      <Box sx={ widgetItemCountStyle } visibility={ loading ? 'hidden' : 'inherit' }>
        { value !== undefined ? value as number : '-' }
      </Box>
      { loading ? <Loader center size={ 1 } color={ YodaColors.inherit } /> : null }
    </Box>
  );
};

export default CountCepWidget;
